import { render, staticRenderFns } from "./order-confirmation-edit.vue?vue&type=template&id=2da9c9f5&scoped=true&"
import script from "./order-confirmation-edit.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-edit.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-edit.vue?vue&type=style&index=0&id=2da9c9f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9c9f5",
  null
  
)

export default component.exports